import { useEffect, useState } from 'react'
import { checkAuth } from '../utils/authCheck'

function MaybeProfileMiddleware({ children }) {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const validate = async () => {
            const accessToken = localStorage.getItem('accessToken');

            if (!accessToken) {
                setChecked(true);
                return;
            }

            try {
                await checkAuth();
            } catch {
                // публичные страницы доступны без авторизации
            } finally {
                setChecked(true);
            }
        }

        validate();
    }, [])

    if (!checked) return null;

    return children;
}

export default MaybeProfileMiddleware
